import { render } from "./ButtonIcon.vue?vue&type=template&id=2d3bf799&scoped=true"
import script from "./ButtonIcon.vue?vue&type=script&lang=js"
export * from "./ButtonIcon.vue?vue&type=script&lang=js"

import "./ButtonIcon.vue?vue&type=style&index=0&id=2d3bf799&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d3bf799"]])

export default __exports__